import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';

import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import Services from '../../service/Services';
import BtnCrearCargo from './BtnCrearCargo'
import BtnActualizarCargo from './BtnActualizarCargo'
import ConfirmBtn from './ConfirmBtn'
import '../../assets/css/DataTable.css';
import axios from 'axios';

const ConsultarCargos = ({ permisosProp }) => {

    const [servicio, setServicio] = useState([]);
    const [loading, setLoading] = useState(true);

    const getServices = new Services();

    useEffect(() => {
        const source = axios.CancelToken.source()
        getServices.getCargos().then(data => {
            if (data !==undefined) {
                setServicio(data)
                setLoading(false)
            }
        });
        return () => {
            if (source) {
                getServices.cancelRequest();
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    var permisoPositionCreate
    if (permisosProp[8].permisos[0] === "Crear") {
        permisoPositionCreate = true
    } else {
        permisoPositionCreate = false
    }
    var permisoPositionUpdate
    if (permisosProp[8].permisos[1] === "Editar") {
        permisoPositionUpdate = true
    } else {
        permisoPositionUpdate = false
    }
    var permisoPositionDelete
    if (permisosProp[8].permisos[2] === "Eliminar") {
        permisoPositionDelete = true
    } else {
        permisoPositionDelete = false
    }

    const Acciones = (rowData) => {
        return (
            <>
                {permisoPositionUpdate ?
                    <BtnActualizarCargo
                        idCargoProp={rowData.id}
                        cargoProp={rowData.cargo}
                        creadoporProp={rowData.creadopor}
                        fechacreacionProp={rowData.fechacreacion}
                        cargosProp={servicio}
                    />
                    :
                    ""
                }
                {permisoPositionDelete ?
                    <ConfirmBtn
                        titulo="Confirmar Eliminación"
                        mensaje="¿Está seguro de eliminar Cargo?, Recuerde que una vez se elimine, se borrará definitivamente del sistema"
                        accion="Eliminar"
                        clase="p-button-danger"
                        icono="pi pi-trash"
                        idCargoProp={rowData.id}
                        tooltipProp="Eliminar"
                    />
                    :
                    ""
                }
            </>
        );
    }

    const [globalFilter, setGlobalFilter] = useState(null);
    const dt = useRef(null);

    const handleChange = (e) => {
        e.preventDefault();
    };

    const header = (
        <div className="headerTable">
            {permisoPositionCreate ?
                <BtnCrearCargo 
                cargosProp={servicio}
                />
                :
                ""
            }
            {loading && <p>Cargando información...</p>}
            <div>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." className="p-column-filter" keyfilter={/^[^<>*!=°|(#$%&"_)+-.:;,/?¡¿'{}]+$/}
                        onCut={handleChange} onCopy={handleChange} onPaste={handleChange}
                    />
                </span>
            </div>
        </div>
    );

    var permisosAcciones
    if (permisoPositionUpdate === false && permisoPositionDelete === false) {
        permisosAcciones = false
    } else {
        permisosAcciones = true
    }

    return (
        <div className="datatable-responsive-demo">
            <div className="card">
                <DataTable ref={dt} value={servicio} className="p-datatable-responsive-demo" paginator rows={10} header={header} globalFilter={globalFilter}
                    emptyMessage="Cargo no registrado en el sistema" loading={loading}>
                    <Column className="columna" field="id" sortable header="Id Cargo" />
                    <Column className="columna" field="cargo" sortable header="Cargo" />
                    {permisosAcciones ?
                        < Column header="Acciones" body={Acciones} />
                        :
                        <Column />
                    }
                </DataTable>
            </div>
        </div>
    );
}

export default ConsultarCargos